import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonModule } from '@angular/material/button';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions, MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { HttpClientModule } from '@angular/common/http';
import { MatCommonModule } from '@angular/material/core';
import { TaskSuccessComponent } from './components/task-success/task-success.component';
import { WorkOrderComponent } from './components/work-order/work-order.component';
import { TopBarComponent } from './components/top-bar/top-bar.component';
import { AuthenticationService } from './services/authentication.service';
import { AuthGuard } from './services/auth.guard';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { LoginComponent } from './components/login/login.component';
import { OAuthModule } from 'angular-oauth2-oidc';
import { RouterModule } from '@angular/router';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';

import { EffectsModule } from '@ngrx/effects';
//import { AuthEffects } from './store/auth/auth.effects';
import { StoreModule, MetaReducer } from '@ngrx/store';
//import { reducers, AppState } from './store/app.reducers';
import { environment } from 'src/environments/environment';
import {  FormlyFieldButton } from './components/custom/button-type.component';
import { ErrorComponent } from './components/error/error.component';
import { FormlyFieldInputWithDelete } from './components/custom/input-with-delete-type.component';
import { ListComponent } from './components/list/list.component';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatTableModule} from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { ToastrModule } from 'ngx-toastr';
import { FormlyFieldButtonWithoutDelete } from './components/custom/button-without-delete-type.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { AutocadIntegrationService } from './services/autocad-integration.service';
import { CheckTokenComponent } from './components/check-token/check-token.component';

declare var registerCallback: any;
const appInitializerFn = (acadIntegration: AutocadIntegrationService, authenticationService: AuthenticationService) => {
  return async () => {

    /* Intentamos registrar el callback para notificar la apertura de proyectos.
      Si falla por error de referencia, asumimos que el metodo registerCallback es desconocido
      y no esta integrado con AutoCAD (el metodo es conocido solo dentro del Chromium de AutoCAD); y,
      establecemos el flag para saber que acciones habilitar */
    try {
      registerCallback("acJsDefun.SetNoteId", acadIntegration.setNoteId);
      acadIntegration.setAutoCADIntegration(true);
      let jwtToken: string = await acadIntegration.getCurrentJWTToken();
      //let jwtToken: string = 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.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.RLZbTw6YEHTG0bMJidD-V9Fsy7H1Kn4L8Mmlp3eigoMFrD8rjtvUNi_AvwFk9HXk9J80zljhePWjChOztcrXIrZSlSjU5lDell7gf1FBrpPEzlDdoODjPLSxmV8H-rKrFZOa3Ykq6IhhPEtm-wgUxW3Y8hfdcb9a91YYDVq1dUpEhhReSoCBDmQ82A5rhNgfb2a3J3ftvbG8L-C638XBtNZkaY5bWZ8dopnJ5mpdeMtITgKyw-TSc6viD8YYxj3pDPznkixb2kjdHqqszhPs5klVxUSychFFZ_b6ZCEOerC_rwCWD0JoHWIpa7upCmkesfDm2RfF9Wl-ekyuXZYQEg';
      console.log(`El token obtenido desde CromoCAD es ${jwtToken}`);
      authenticationService.setAccessToken(jwtToken);

      // Escucha eventos ACAD de descarga de archivos
      acadIntegration.registerCallbackDownloads();
    } catch (error) {
      if (error.constructor === ReferenceError) {
        console.log('La aplicación no se encuentra integrada a AutoCAD.');
      } else {
        console.error(error);
      }
    }

    
    return;
  };
};

/*
export const metaReducers: MetaReducer<AppState>[] = !environment.production
  ? []
  : [];
*/
const appearance: MatFormFieldDefaultOptions = {
  appearance: 'outline'
};

@NgModule({
  declarations: [
    AppComponent,
    WorkOrderComponent,
    TaskSuccessComponent,
    TopBarComponent,
    LoginComponent,
    FormlyFieldButton,
    FormlyFieldButtonWithoutDelete,
    FormlyFieldInputWithDelete,
    ErrorComponent,
    ListComponent,
    ConfirmationDialogComponent,
    CheckTokenComponent,
  ],
  imports: [
    FormsModule,
    BrowserAnimationsModule,
    MatButtonModule,
    BrowserModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormlyBootstrapModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatDialogModule,
    ToastrModule.forRoot({
      timeOut: 10000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
    }),

    FormlyModule.forRoot({
      types: [
        {
          name: 'button',
          component: FormlyFieldButton,
          wrappers: ['form-field'],
          defaultOptions: {
            templateOptions: {
              btnType: 'default',
              type: 'button',
            },
          },
        },
        {
          name: 'button-without-delete',
          component: FormlyFieldButtonWithoutDelete,
          wrappers: ['form-field'],
          defaultOptions: {
            templateOptions: {
              btnType: 'default',
              type: 'button-without-delete',
            },
          },
        },
        {
          name: 'input-with-delete',
          component: FormlyFieldInputWithDelete,
          wrappers: ['form-field'],
          defaultOptions: {
            templateOptions: {
              btnType: 'default',
              type: 'button',
            },
          },
        },
        //{ name: 'input-with-delete', component: FormlyFieldInputWithDelete },

      ],
      validationMessages: [
        { name: 'required', message: 'Este campo es obligatorio' },
      ],
    }),
    FormlyMaterialModule,
    AppRoutingModule,
    MatCommonModule,

    /*
    StoreModule.forRoot(reducers, {
      metaReducers,
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true
      }
    }),
    EffectsModule.forRoot([ AuthEffects]),
    */
    OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: [ '/notas-backend/api/v1.0/types', '/notas-backend/api/v1.0/states', '/notas-backend/api/v1.0/prioryties', '/service-profile/api/v1.0/profiles',
         '/notas-backend/api/v1.0/workorders', '/notas-backend/api/v1.0/workorders-data' ],
        sendAccessToken: true
    }
    }),
    RouterModule,
  ],
  exports: [
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatTableModule,
  ],
  providers: [
    AuthGuard,
    AuthenticationService,
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: appearance
    },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      multi: true,
      deps: [AutocadIntegrationService, AuthenticationService]
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
